// Dependencies
require("section/faq");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/faq/index.js
 ** module id = 171
 ** module chunks = 0 1
 **/